import { render, staticRenderFns } from "./productDetailsLoader.vue?vue&type=template&id=62614000"
import script from "./productDetailsLoader.ts?vue&type=script&lang=js&external"
export * from "./productDetailsLoader.ts?vue&type=script&lang=js&external"
import style0 from "./productDetails.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports